import React from 'react';
import { useHistory } from 'react-router-dom';

import { AppPageMain } from '@ru-digital-assets/ui-component';

import SignedComplete from '../../containers/signed-complete';
import PageHeader from '../../modules/page-header';

const FinalPage: React.FC = () => {
  const history = useHistory();

  const {
    title,
    titlePage,
    description,
    items,
    iconType,
    tabName,
  } = history.location.state;

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader items={items} iconType={iconType} tabName={tabName} />
          </div>
        </div>

        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <SignedComplete
              title={title}
              titlePage={titlePage}
              description={description}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default FinalPage;
